import { useState } from 'react';
import styles from '../../../styles/modules/RegistrationSetup.module.css';
import { MdContentCopy, MdOutlineModeEditOutline } from "react-icons/md";
import { useNavigate } from 'react-router';
import { FormTemplateAPI } from '../../../api/FormTemplateAPI';
import { Privileges } from '../../../util/PrivilegeConstants';
import { Menu, MenuItem } from '@mui/material';
import { AiTwotoneDelete } from "react-icons/ai";
import { CiMenuKebab } from "react-icons/ci";
import { IoEyeOutline } from "react-icons/io5";
import { useDispatch } from 'react-redux';
import { rootAction } from '../../../redux/reducer/rootReducer';
import CustomAlertDialog from '../../CustomComponents/CustomAlertDialog';

const FormTemplateCard = ({ formTemplate, clubId, userId, setIsLoading, privileges, setIsRefresh }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [alertDialog, setAlertDialog] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const timeFormatOptions = {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour12: true,
        hour: '2-digit',
        minute: '2-digit'
    }

    const handleDuplicateFormTemplate = async () => {
        try {
            setIsLoading(true);
            await FormTemplateAPI.postDuplicateFormTemplate({
                clubId: clubId,
                formTemplateId: formTemplate.id,
                createdBy: userId
            })
            setIsRefresh(true)
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };
    const handleDeleteInProgressFormTemplates = async () => {
        try {
            setIsLoading(true);
            await FormTemplateAPI.deleteInProgressFormTemplate(clubId, formTemplate.id);
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'success', content: 'Form template deleted successfully' }))
            setIsRefresh(true);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };
    const downloadFormTemplate = async () => {
        try {
            setIsLoading(true);
            const response = await FormTemplateAPI.downloadFormTemplate(clubId, formTemplate.id);
            const url = window.URL.createObjectURL(response);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'registration_form.pdf');
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className={styles['form_template_card_con']}>
            {privileges?.MANAGE_FORM_TEMPLATE?.includes(Privileges.MODIFY) &&
                <CiMenuKebab className={styles['form_template_card_edit']} onClick={(e) => {
                    setAnchorEl(e.currentTarget)
                }} />}
            <div className="free_trial-badge">
                <p>{formTemplate?.status?.replace('_', ' ')}</p>
            </div>
            <div className={styles['form_template_card_heading']}>
                <h3>{formTemplate?.name}</h3>
                <h4>{new Date(formTemplate?.createdDate).toLocaleString('en-US', timeFormatOptions)}</h4>
            </div>
            <div className={styles['form_template_card_created']}>
                <h3>Created By</h3>
                <h4>{formTemplate?.createdByName}</h4>
            </div>
            {/* <div className={styles['form_template_action']}>
                <button><FaEye />Preview</button>
                <button onClick={downloadFormTemplate}><BsDownload />Download</button>
            </div> */}
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                {privileges?.MANAGE_FORM_TEMPLATE?.includes(Privileges.MODIFY) &&
                    <MenuItem onClick={() => {
                        navigate("/form-settings", {
                            state: {
                                formTemplateId: formTemplate.id
                            }
                        })
                    }
                    }>
                        {formTemplate?.status === 'IN_PROGRESS' ?
                            <>
                                <MdOutlineModeEditOutline className={styles['cus_form_fields_edit_icon']} />Edit
                            </>
                            :
                            <>
                                <IoEyeOutline className={styles['cus_form_fields_edit_icon']} />View
                            </>}
                    </MenuItem>}
                {privileges?.MANAGE_FORM_TEMPLATE?.includes(Privileges.CREATE) &&
                    <MenuItem onClick={() => {
                        handleDuplicateFormTemplate();
                        setAnchorEl(null)
                    }}><MdContentCopy className={styles['cus_form_fields_edit_icon']} />Duplicate</MenuItem>}
                {(privileges?.MANAGE_FORM_TEMPLATE?.includes(Privileges.DELETE) && (formTemplate?.status === 'IN_PROGRESS' || formTemplate?.status === 'REJECTED')) &&
                    <MenuItem onClick={() => {
                        setAlertDialog(true)
                        setAnchorEl(null)
                    }}><AiTwotoneDelete className={styles['cus_form_fields_edit_icon']} />Delete</MenuItem>}
            </Menu>
            <CustomAlertDialog isOpen={alertDialog} title="Alert"
                message={"Are you sure you want to delete this field?"}
                onCancel={() => setAlertDialog(false)}
                onClose={() => setAlertDialog(false)}
                onSubmit={handleDeleteInProgressFormTemplates}
                submitBtnName='Delete'
            />
        </div>
    )
}

export default FormTemplateCard